import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonText, IonLabel, IonFooter, IonIcon } from '@ionic/react';
import { trashOutline } from "ionicons/icons";

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

//import '../css/hotelCss.css';
//import '../../../../css/qavaApp.css';
import '../../../css/layout.css';

import { UpdateCheckOutDateModal } from './Modal_Update_checkOutDate';
import { UpdateRoomModal } from './Modal_UpdateRoom';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { MenuModal } from './Modal_Menu';

import { format, compareAsc, differenceInDays } from 'date-fns';

import {v4 as uuid} from 'uuid';


export function OccupiedRoomDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [merchantPhoneNumber, setMerchantPhoneNumber ] = useState(authenticatedMerchent_context.companyPhoneNumber);
    const [merchantPhoneNumber_mtnMomo, setMerchantPhoneNumber_mtnMomo ] = useState(authenticatedMerchent_context.mtnCompanyPhoneNumber);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date());
    let [endDate, setEndDate] = useState(new Date());
    let [numOfNights, setNumOfNights] = useState(0);

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [numberOfNights, setDateRangeNumberOfNights] = useState(null);
    let [guestPayAmount, setGuestPayAmount] = useState(null);

    let [checkInInvoice_send, setCheckInInvoice_send] = useState(null);
    let [checkInInvoice_sent, setCheckInInvoice_sent] = useState(null);
    let [checkInInvoice_confirmPaid, setCheckInInvoice_confirmPaid] = useState(null);
        let [checkInInvoice_confirmPaid_non_member, setCheckInInvoice_confirmPaid_non_member] = useState(null);
    let [checkInInvoice_paid, setCheckInInvoice_paid] = useState(null);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [disableCheckOutButton, setDisableCheckOutButton] = useState(false);

    let [viewInventoryOccupiedRoomDetailData, setViewInventoryOccupiedRoomDetailData] = useState([]);
    let [menuItemsList, setMenuItemsList] = useState([]);

    let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showMenuModal, setViewMenuModal] = useState(false);
    let [showUpdateCheckOutDateModal, setShowUpdateCheckOutDateModal] = useState(false);
    let [showUpdateRoomModal, setShowUpdateRoomModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomGuestPhoneNumber, setRoomGuestPhoneNumber] = useState('');
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [invoiceID, setInvoiceID] = useState(null);
    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);
    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);

    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);

    let [displaySetButton_pay, setDisplaySetButton_pay] = useState('inline-block');
    let [displayResetButton_pay, setDisplayResetButton_pay] = useState('none');
    let [disableSetButton_pay, setDisableSetButton_pay] = useState(false);
    let [disableResetButton_pay, setDisableResetButton_pay] = useState(false);

    let [displaySetButton, setDisplaySetButton] = useState('none');
    let [displayResetButton, setDisplayResetButton] = useState('inline-block');

    let [disableCheckInButton, setDisableCheckInButton] = useState(false);
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [disableRefundButton, setDisableRefundButton] = useState(false);

    let [displaySetButton_refund, setDisplaySetButton_refund] = useState('inline-block');
    let [displayResetButton_refund, setDisplayResetButton_refund] = useState('none');
    let [disableSetButton_refund, setDisableSetButton_refund] = useState(false);
    let [disableResetButton_refund, setDisableResetButton_refund] = useState(false);

    let [momo_provider, setMomoProvider] = useState('');
    let [momo_financial_transaction_id, setFinancialTransactionId] = useState(''); 
    let [momo_external_id, setExternalId] = useState('');
    let [momo_amount, setAmount] = useState('');
    let [momo_currency, setCurrency] = useState('');
    let [momo_party_id_type, setPartyIdType] = useState('');
    let [momo_party_id, setPartyId] = useState('');
    let [momo_payer_message, setPayerMessage] = useState('');
    let [momo_payee_note, setPayeeNote] = useState('');
    let [momo_pay_status, setPayStatus] = useState('');

    let [momo_pay_status_db, setPayStatus_db] = useState('');

    let [internalReferenceID, setInternalReferenceID] = useState('');

    let enterPayRef = useRef(0);
    let paymentTypeRef = useRef('MTN-MOMO');

    let enterDepositRef = useRef(0);
    let enterRefundRef = useRef(0);

    let enterDiscountRef = useRef(0);
    let enterIncreaseRef = useRef(0);

    const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };
   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

            /*
            let formData = new FormData();
            formData.append('Tracker', 74112);
            formData.append('user', acctID);
            formData.append('xCheckInRoomID', props.data.roomID);
            //formData.append('xStartDateRange', props.data.checkInDateActual);
            formData.append('xInvoiceID', props.data.merchantInvoiceID);

        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */
            let Tracker;
            if(props.data.status == "checked_out")
            {
               Tracker = "74112_checked_out"; 
            }
            else
            {
                Tracker = "74112";
            }
            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: Tracker,
                    user: acctID,
                    xCheckInRoomID: props.data.roomID,
                    xInvoiceID: props.data.merchantInvoiceID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
    
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');
                    
                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;


                    timeDiff = Math.abs(differenceInDays(
                        new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                        new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                      ));

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        setGuestPayAmount(parseFloat(cols[26]).toFixed(2));
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        setGuestPayAmount(parseFloat(cols[26]).toFixed(2));

                    }
        
                    if(cols[25] == 'N')
                    {
                        if(cols[29] == "C" && (parseFloat(cols[26]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) == 0.00)
                        {
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[29] == "C" && (parseFloat(cols[26]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) > 0.00)
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                                setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                    setPayStatus_db(cols[37]);
                    //alert(cols[29]);


                    setViewInventoryOccupiedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: parseFloat(cols[8]).toFixed(2),
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            invoiceTotalAmount: cols[26],
                            transactionID: cols[27],
                            transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                            transactionStatus: cols[29],
                            momo_provider: cols[30],
                            momo_financial_transaction_id: cols[31],
                            momo_external_id: cols[32],
                            momo_amount: cols[33],
                            momo_party_id: cols[34],
                            momo_payer_message: cols[35],
                            momo_payee_note: cols[36],
                            momo_pay_status: cols[37],
                            payment_type: cols[38],
                            roomGuestInvoiceAttachment: cols[39],
                            menu_items: parseArray(cols[40]),
                            internalReferenceID: cols[41],

                        })

                    });
                    setRoomGuestPhoneNumber(cols[16]);
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                    setInternalReferenceID(cols[41]);

                }    
            })
    }, []);

    function sendToCustomer(event)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74108);
        formData.append('user', acctID);
        formData.append('xQavaMemberID', event[2]);
        formData.append('xInvoiceID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108',
                user: acctID,
                xQavaMemberID: event[2],
                xInvoiceID: props.event[0],
                xCustomerInvoiceID: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let cols = data.toString().split('|');


            if(cols[0] == 'sent1' && cols[1] == 'inserted1')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('inline-block');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

            }
            else
            {
                alert('Sent transaction incomplete');
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment(event)
    {
        let tracker = event[3];
        let customerInvoiceID = event[1];
        let transactionID = event[0];
        let customerPhoneNumber = event[2];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            if (data == 'confirmed')
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'none';
                document.getElementById(transactionID + 'pr').style.display = 'none';
                document.getElementById(transactionID + 'c').style.display = 'inline-block';
                document.getElementById(transactionID + 'r').style.display = 'none';*/
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
            else
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'inline-block';
                document.getElementById(transactionID + 'pr').style.display = 'inline-block';
                document.getElementById(transactionID + 'c').style.display = 'none';
                document.getElementById(transactionID + 'r').style.display = 'inline-block';*/

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('inline-block');
                setCheckInInvoice_paid('none');

                alert('Payment Sent To Customer');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
        })
    }

    function submitPay(event)
    {

        setDisablePayButton(true);
        let xReferenceID = uuid();
        //setInternalReferenceID(xReferenceID);

        if (paymentTypeRef.current.value == 'cash'|| paymentTypeRef.current.value == 'CASH')
        {
            //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);
            prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString()]);

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
            const apikey = "e288a3938db14c8c9dfe3543427a141e";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            //alert("BEFORE PAY");
            //alert(merchantPhoneNumber.replace(/^0+/, ''));
            //alert(merchantPhoneNumber);

            fetch(baseURL+'mtnapi/collection/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'x-internal-reference-id': internalReferenceID,
                    'tracker': '74108_B_update_successful',
                    'user': acctID,
                    'customer_account_id': 'non_member',
                    'schema': schema,
                    'x_ProjectID': "N/A",
                    'x_customer_mobilenumber': event[3],
                    'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': acctID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'collection/v1_0/requesttopay',
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },

            })
            .then(res => res.json())
            .then(res => {


                prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status]);

            })
        })
    }

    function submitPay_refund(event)
    {

        setDisablePayButton(true);

        if (paymentTypeRef.current.value == 'CASH')
        {
            refund([event, paymentTypeRef.current.value]);

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "0a8356fc-ce44-4436-a976-68a954d94094";
            const apikey = "9070094e5ece4fabb351a0e282043cee";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let referenceIdToRefund = "";
            if (event[10] == 'refund' || event[10] == 'transfer') {

                alert("In refund alert");
                alert(event);
                alert(event[9]);
                referenceIdToRefund = event[9];
            }

            //let xReferenceID = uuid();

            let body_refund = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": referenceIdToRefund,
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote,
                "referenceIdToRefund": referenceIdToRefund,
            }
            let body_transfer = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": referenceIdToRefund,
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let body_deposit = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": referenceIdToRefund,
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let fetch_body;

            if(event[10] == 'refund')
            {
                alert("In Refund"); 
                fetch_body = body_refund;
            }
            else if(event[10] == 'transfer')
            {
                alert("In transfer"); 
                fetch_body = body_transfer;
            }
            else if(event[10] == 'deposit')
            {
                alert("In deposit"); 
                fetch_body = body_deposit;
            }

            fetch(baseURL+'mtnapi/disbursement/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                //credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': referenceIdToRefund,
                    'user': acctID,
                    'customer_account_id': 'non_member',
                    'x_project_id': 'N/A',
                    'x_customer_mobilenumber': event[3],
                    'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': acctID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'disbursement/v1_0/'+event[10],
                    'confirm_payment': 'confirm_or_reject_refund',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    //'external_id': xReferenceID.toString(),
                    'external_id': referenceIdToRefund,
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },
                body: JSON.stringify(fetch_body),


            })
            .then(res => res.json())
            .then(res => {

                alert(res);

                refund([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payee.partyIdType, res.payee.partyId, res.payerMessage, res.payeeNote, res.status]);

            })
        })
    }

    function prepareInvoice_thenConfirmPay_nonMember(event)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74108_B');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xPaymentType: event[1],
                xMomo_provider: event[2],
                xMomo_financial_transaction_id: event[3],
                xMomo_external_id: event[4],
                xMomo_amount: event[5],
                xMomo_currency: event[6],
                xmomo_party_id_type: event[7],
                xMomo_party_id: event[8],
                xMomo_payer_message: event[9],
                xMomo_payee_note: event[10],
                xMomo_pay_status: event[11],
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


            confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);


            /*let cols = data.toString().split('|');


            if(cols[0] == 'prepared1')
            {

                //setCheckInInvoice_send('none');
                //setCheckInInvoice_sent('inline-block');
                //setCheckInInvoice_confirmPaid('none');
                //setCheckInInvoice_paid('none');


            }
            else
            {
            }*/
        })
        .catch(error => {
            console.error(error);
        })
    }


    function refund(event)
    {

        setDisableRefundButton(true);
        alert(event[3]);

        /*let formData = new FormData();
        formData.append('Tracker', '74108_B_refund');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }*/
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_refund',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xPaymentType: event[1],
                xMomo_provider: event[2],
                xMomo_financial_transaction_id: event[3],
                xMomo_external_id: event[4],
                xMomo_amount: event[5],
                xMomo_currency: event[6],
                xmomo_party_id_type: event[7],
                xMomo_party_id: event[8],
                xMomo_payer_message: event[9],
                xMomo_payee_note: event[10],
                xMomo_pay_status: event[11], 
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function merchant_nonMember_update_transaction_status(event)
    {
        //setDisableRefundButton(true);



        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_update',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xMomo_provider: event[1],
                xMomo_financial_transaction_id: event[2],
                xMomo_external_id: event[3],
                xMomo_amount: event[4],
                xMomo_currency: event[5],
                xmomo_party_id_type: event[6],
                xMomo_party_id: event[7],
                xMomo_payer_message: event[8],
                xMomo_payee_note: event[9],
                xMomo_pay_status: event[10],
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment_non_member(event)
    {
        //alert(event);
        //alert(event[8]);

        let tracker = event[4];
        let customerInvoiceID = event[2];
        let transactionID = event[0];
        let customerPhoneNumber = event[3];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                fmc_schema: schema,
                baseUrl: baseURL,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xCheckInRoomID: event[5],
                sessionID: sessionID,
                xPaymentType: event[6],
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16], 
                xInternalReferenceID: internalReferenceID,

            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert('Client Partial Payment Confirmed');
            alert(data);

        })
    }

    function setPayHandler()
    {
        setDisableSetButton_pay(true);
        setDisplaySetButton_pay('none');
        setDisableResetButton_pay(false);
        setDisplayResetButton_pay('inline-block');

    }

    function resetPayHandler()
    {
        setDisableResetButton_pay(true);
        setDisplayResetButton_pay('none');
        enterPayRef.current.value = '';
        setDisableSetButton_pay(false);
        setDisplayResetButton_pay('none');
        setDisplaySetButton_pay('inline-block');
    }

    function setRefundHandler()
    {
        setDisableSetButton_refund(true);
        setDisplaySetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton_refund(false);
        setDisplayResetButton_refund('inline-block');

    }

    function resetRefundHandler()
    {
        setDisableResetButton_refund(true);
        setDisplayResetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterRefundRef.current.value = '';
        setDisableSetButton_refund(false);
        setDisplayResetButton_refund('none');
        setDisplaySetButton_refund('inline-block');
    }

    function handleUpdate_checkOutDate(event)
    {

        setStartDate(event[1]);
        setEndDate(event[2]);
        setShowUpdateCheckOutDateModal(event[0]);
    }

    function handleUpdate_room(event)
    {

        setStartDate(event[1]);
        setEndDate(event[2]);
        setShowUpdateRoomModal(event[0]);
    }

    function onSubmitNewDateHandler(e)
    {

        //setViewInventoryOccupiedRoomDetailData([]);

        let date1 = new Date(new Date(startDate.toLocaleString('en-US', {timeZone: 'Greenwich Mean Time',})));
        let date2 = new Date(new Date(e[1]));
        let timeDiff;
        let currentDate = '';


        timeDiff = Math.abs(differenceInDays(
            new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
            new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
          ));


        setStartDate(date1);
        setEndDate(date2);
        setDateRangeNumberOfNights(timeDiff);
        currentDate = new Date(Date.now() + 86400000).toISOString().substring(0, 10);


        if(date1.getDate() == date2.getDate())
        {
            timeDiff = 1;
            //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));

           // setGuestPayAmount(parseFloat(cols[26]).toFixed(2));

        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_U_OUT',
                user: acctID,
                xCheckInRoomID: props.data.roomID,
                xStartDateRange: date1.toISOString().substr(0, 10),
                xEndDateRange: date2.toISOString().substr(0, 10),
                xCurrentDateRange: currentDate,
                xCheckInNumberOfNights: timeDiff,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
        
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                let date1 = new Date(cols[20]);
                let date2 = new Date(cols[21]);
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));

                if(date1.getDate() == date2.getDate())
                {
                    setDateRangeNumberOfNights(1);
                    //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));

                    setGuestPayAmount(parseFloat(cols[26]).toFixed(2));

                }
                else
                {
                    setDateRangeNumberOfNights(timeDiff);
                    //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                    setGuestPayAmount(parseFloat(cols[26]).toFixed(2));


                }

                setViewInventoryOccupiedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                    return prevViewInventoryOccupiedRoomDetailData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomDescription: cols[2],
                        roomPartNum: cols[3],
                        roomPhoneNumber: cols[4],
                        address: cols[5],
                        city: cols[6],
                        country: cols[7],
                        roomSalePrice: parseFloat(cols[8]).toFixed(2),
                        roomPic1: cols[9],
                        roomPic2: cols[10],
                        roomPic3: cols[11],
                        roomPic4: cols[12],
                        attachment: cols[13],
                        roomGuestFirstName: cols[14],
                        roomGuestLastName: cols[15],
                        roomGuestPhoneNumber: cols[16],
                        roomGuestEmail: cols[17],
                        roomGuestPaymentType: cols[18],
                        roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                        roomGuestCheckInDateBooked: cols[20],
                        roomGuestCheckOutDateBooked: cols[21],
                        roomGuestCheckInDateActual: cols[22],
                        merchantInvoiceID: cols[23],
                        customerInvoiceID: cols[24],
                        invoiceSentStatus: cols[25],
                        invoiceTotalAmount: cols[26],
                        transactionID: cols[27],
                        transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                        transactionStatus: cols[29],
                        momo_provider: cols[30],
                        momo_financial_transaction_id: cols[31],
                        momo_external_id: cols[32],
                        momo_amount: cols[33],
                        momo_party_id: cols[34],
                        momo_payer_message: cols[35],
                        momo_payee_note: cols[36],
                        momo_pay_status: cols[37],
                        payment_type: cols[38],
                        roomGuestInvoiceAttachment: cols[39],
                        menu_items: parseArray(cols[40]),
                    })

                });
                setRoomGuestPhoneNumber(cols[16]);
                setRoomSalePrice(parseFloat(cols[19]).toFixed(2));

            }

            //alert('Room Check-Out Date Has been updated to '+e);
            alert(data);

            setShowUpdateCheckOutDateModal(false);
            props.closeModal_updateComplete();
            
        })
        .catch(error => {
            console.error(error);
        })

    }

    function updateGuestPhoneNumber(event)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74125);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '11_update_guest_phoneNumber',
                user: acctID,
                fmc_schema: schema,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                xMerchantInvoiceID: event[2],
                xCustMobileNumber: roomGuestPhoneNumber,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

    }
    function checkOutGuest(event)
    {
        setDisableCheckOutButton(true);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74125);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74125',
                user: acctID,
                fmc_schema: schema,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let cols = data.toString().split('|');


            if(cols[0] == 'checked_out')
            {            
                alert('Room ' + event[0] + 'Successfully Checked out');

                props.closeModal(false);

            }
            else
            {
                alert('Room Checkout Unsuccessful');
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteMenuItem(event)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '7999_delete_menuItem',
                user: acctID,
                fmc_schema: schema,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                xInvoiceID: event[2],
                xProductID: event[3],
                xDelete_quantity: event[4],
                xDelete_lineNumberMenu: event[5],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            props.closeModal_updateComplete();
        })
        .catch(error => {
            console.error(error);
        })
    }

    function force_deleteCheckIn(event)
    {

        /*let formData = new FormData();
        formData.append('Tracker', '7999_delete');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        //alert(event);
        //alert(event[2]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '7999_delete',
                user: acctID,
                fmc_schema: schema,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                xInvoiceID: event[2],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let cols = data.toString().split('|');


            if(cols[0] == 'check_in_deleted')
            {            
                alert('Room ' + event[0] + 'Check-In Deleted');

                props.closeModal(false);

            }
            else
            {
                alert('Deletion Unsuccessful');
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function applyDiscount(event, newRoomSalePrice)
    {
        // alert("in apply Discount");
        // alert(event);
        // alert(newRoomSalePrice);

        /*let formData = new FormData();
        formData.append('Tracker', '7999_delete');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_applyDiscount_roomOccupied',
                user: acctID,
                xCheckInRoomID: event[0],
                xInvoiceID: event[1],
                xCustomerInvoiceID: event[2],
                xCheckInNumberOfNights: numberOfNights,
                xCheckInNonMemberPaymentAmount: parseFloat(newRoomSalePrice).toFixed(2),
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            setViewInventoryOccupiedRoomDetailData([]);
            props.closeModal(false);
            
        })
        .catch(error => {
            console.error(error);
        })
    }

    function viewInvoiceModalHandler(event) {


        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setRoomGuestInvoiceAttachment(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function viewMenuModalHandler(event) {


        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setInvoiceID(event[3]);
        setCustomerInvoiceID(event[4]);
        setRoomGuestInvoiceAttachment(event[5]);
        setViewMenuModal(event[0]);

    }

    function setDiscountHandler(event)
    {

        //alert(event);

        if(enterIncreaseRef.current.value > 0)
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
           // setBookingPrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
            setDisableResetButton(false);
    
            if(checkInRoomID_multiple != null)
            {
                let newRoomSalesPrice_Multiple = [];
    
                for(let i = 0; i < roomSalePrice_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] + (roomSalePrice_multiple[i]*(enterIncreaseRef.current.value/100)));
                }
                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
            }

            applyDiscount(event, roomSalePrice + (roomSalePrice*(enterDiscountRef.current.value/100)));

        }
        else
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            //setBookingPrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            setDisableResetButton(false);
    
            if(checkInRoomID_multiple != null)
            {
                let newRoomSalesPrice_Multiple = [];
    
                for(let i = 0; i < roomSalePrice_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] - (roomSalePrice_multiple[i]*(enterDiscountRef.current.value/100)));
                }
                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
            }

            applyDiscount(event, roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));

        }
    }
    
    function resetDiscountHandler(event)
    {
        setDisableResetButton(true);
        setDisplaySetButton('inline-block');
        setDisplayResetButton('none');
        setRoomSalePrice(event);
        enterDiscountRef.current.value = 0;
        enterIncreaseRef.current.value = 0;
        setDisableSetButton(false);
    }

    function closeModalHandler() {

        setViewInventoryOccupiedRoomDetailData([]);
        props.closeModal(false);
    }

    function closeModalHandler_complete() {

        setViewInventoryOccupiedRoomDetailData([]);
        props.closeModal_updateComplete(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
            <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h3>ROOMS OCCUPIED</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> Room ID</IonCol>
                        <IonCol size='6'> Price Per Night</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> {props.data.roomID} </IonCol>
                        <IonCol size='6'> {props.data.roomSalePrice} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

            {viewInventoryOccupiedRoomDetailData.map((detailData) =>   {
            return (
            <IonGrid>
                <IonRow >
                    <IonCol size='3' ><h3>Category</h3></IonCol>
                    <IonCol size='6' ><h3>Value</h3></IonCol>
                    <IonCol size='3' ><h3>Action</h3></IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ><IonLabel>Invoice</IonLabel></IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{detailData.merchantInvoiceID}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestInvoiceAttachment])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ><IonLabel>Add Menu Item</IonLabel></IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{detailData.merchantInvoiceID}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewMenuModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestInvoiceAttachment])}> Add Menu </IonButton>
                    </IonCol>
                </IonRow>
                        <IonRow className="outlinedRow">
                            <IonCol >DESCRIPTION</IonCol>
                        </IonRow>
                        <IonRow className="outlinedRow outlinedHeader">
                            <IonCol size='2'>Qty</IonCol>
                            <IonCol size='4'>Desc</IonCol>
                            <IonCol size='2'>Unit</IonCol>
                            <IonCol size='2'>Total</IonCol>
                            <IonCol size='2'>Del</IonCol>
                        </IonRow>
                        {detailData.menu_items.map((it) => {
                            return (
                                <IonRow className="outlinedRow">
                                    <IonCol size='2'>
                                        {it.qty}
                                    </IonCol>
                                    <IonCol size='4'>
                                        {it.description}                              
                                    </IonCol>
                                    <IonCol size='2'>
                                        {it.unit_price}                              
                                    </IonCol>
                                    <IonCol size='2'>
                                        {it.extended_price}                              
                                    </IonCol>
                                    <IonCol size='2'>
                                            <IonButton fill="clear" size="small" onClick={() => deleteMenuItem([detailData.roomID, detailData.customerInvoiceID, detailData.merchantInvoiceID, it.product_id, it.qty, it.line_number_menu])}>
                                                    <IonIcon icon={trashOutline} />
                                            </IonButton>
                                    </IonCol>
                                </IonRow>
                            )}
                        )}
                <IonRow >
                    <IonCol size='3' >Change Room</IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{ 'ID: '+detailData.roomID+'Part #: '+detailData.roomPartNum}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton onClick={() => handleUpdate_room([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Room Images</IonCol>
                    <IonCol size='6' >{detailData.roomType}</IonCol>
                    <IonCol size='3' >
                        <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: detailData.roomPic1, 
                        roomPic2: detailData.roomPic2, 
                        roomPic3: detailData.roomPic3, 
                        roomPic4: detailData.roomPic4, 
                        roomID: detailData.roomID, 
                        roomSalePrice: detailData.roomSalePrice
                        }}></ShowRoomPicsModal>
                        <IonButton  onClick={() => setRoomPicsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-In Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckInDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-Out Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckOutDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton onClick={() => handleUpdate_checkOutDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ># of Nights</IonCol>
                    <IonCol size='6' >{numberOfNights}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Name</IonCol>
                    <IonCol size='6' style={{fontSize: 'small'}}>{detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Mobile</IonCol>
                     <IonCol size='6' >
                        <IonInput className='professional-input' type='text' value={ roomGuestPhoneNumber }  placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setRoomGuestPhoneNumber(e.target.value)} required></IonInput>
                    </IonCol>
                    <IonCol size='3' >
                        <IonButton onClick={() => updateGuestPhoneNumber([detailData.roomID, detailData.customerInvoiceID, detailData.merchantInvoiceID,])}> Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Email</IonCol>
                    <IonCol size='6' >{detailData.roomGuestEmail}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Room Price</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPrice}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Payment Type</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPaymentType}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Amount Paid</IonCol>
                    <IonCol size='6' >{detailData.transactionTotalAmount}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <h4>Discount: </h4>
                    </IonCol>
                    <IonCol size='4'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDiscountRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{(( ( (detailData.roomSalePrice * numberOfNights) - guestPayAmount )/ (detailData.roomSalePrice * numberOfNights)) * 100).toFixed(2)+' %'}</h4>
                    </IonCol>
                    <IonCol size='4'> 
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler([detailData.roomID, detailData.merchantInvoiceID, detailData.customerInvoiceID])}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler(detailData.roomSalePrice)}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Balance</IonCol>
                    <IonCol size='6' >{(parseFloat(guestPayAmount) + parseFloat(detailData.transactionTotalAmount)).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Pay</IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton_pay}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton_pay}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_pay}} disabled={disableSetButton_pay} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_pay}} disabled={disableResetButton_pay} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                    <IonCol size='3' >
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (detailData.momo_pay_status == '' || detailData.momo_pay_status == 'NO_RESPONSE' || detailData.momo_pay_status == 'FAILED' || detailData.momo_pay_status == 'N/A' || detailData.momo_pay_status == 'SUCCESSFUL' || detailData.momo_pay_status == 'CASH')) &&   <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B', enterPayRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName])}> PAY</IonButton>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (detailData.momo_pay_status  == 'PENDING' || detailData.momo_pay_status  == 'CREATED')) &&   <IonButton id='gridResultColumnButton' disabled={true} > Pending</IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-Out Guest</IonCol>
                    <IonCol size='6' >{'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' >
                        {/*<p  style={{display: checkInInvoice_confirmPaid_non_member}}> Need To Pay </p>*/}
                        {/*<IonButton  disabled={disableCheckOutButton} style={{display: checkInInvoice_paid}} onClick={() => checkOutGuest([detailData.roomID, detailData.customerInvoiceID])}> Check-Out </IonButton>*/}
                        <IonButton  disabled={disableCheckOutButton} onClick={() => checkOutGuest([detailData.roomID, detailData.customerInvoiceID])}> Check-Out </IonButton>
                    </IonCol>
                </IonRow>
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow >
                    <IonCol size='3' >FORCE Check-Out</IonCol>
                    <IonCol size='6' >{'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' >
                        <IonButton  disabled={disableCheckOutButton} onClick={() => checkOutGuest([detailData.roomID, detailData.customerInvoiceID])}> Check-Out </IonButton>
                    </IonCol>
                </IonRow>}
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow >
                    <IonCol size='3' >FORCE Delete</IonCol>
                    <IonCol size='6' >{'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' >
                        <IonButton  disabled={disableCheckOutButton} onClick={() => force_deleteCheckIn([detailData.roomID, detailData.customerInvoiceID, detailData.merchantInvoiceID])}> Delete </IonButton>
                    </IonCol>
                </IonRow>}
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow>
                    <IonCol size='3'>
                        REFUND
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton_refund}} type='number' placeholder='Enter %' ref={enterRefundRef}></IonInput>
                        <h4 style={{display: displayResetButton_refund}}>{enterRefundRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_refund}} disabled={disableSetButton_refund} onClick={() => setRefundHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_refund}} disabled={disableResetButton_refund} onClick={() => resetRefundHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol size='3'>
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.momo_external_id, 'refund'])}> Refund </IonButton>}
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.momo_external_id, 'transfer'])}> Transfer </IonButton>}
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.momo_external_id, 'deposit'])}> Deposit </IonButton>}
                    
                    </IonCol>
                </IonRow>
            }
            </IonGrid>
                    )
                }
            )}
        {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        }}></ViewInvoiceModal>}
        
        {showMenuModal == true && <MenuModal openModal={ showMenuModal } closeModal={() => setViewMenuModal(false)} closeModal_update={() => props.closeModal_updateComplete()} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        invoiceID: invoiceID,
                                        customerInvoiceID: customerInvoiceID,
                                        }}></MenuModal>}

        {showUpdateCheckOutDateModal == true && <UpdateCheckOutDateModal openModal={ showUpdateCheckOutDateModal } closeModal={() => setShowUpdateCheckOutDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckOutDateModal>}

        {showUpdateRoomModal == true && <UpdateRoomModal openModal={ showUpdateRoomModal } closeModal={() => setShowUpdateRoomModal(false)} closeModal_updateComplete={() => closeModalHandler_complete()} startDate={new Date(startDate).toISOString().substr(0, 10)} endDate={new Date(endDate).toISOString().substr(0, 10)} currentRoom={props.data.roomID} currentRoom_multiple={false}></UpdateRoomModal>}

        </IonContent>
        <IonFooter className='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
    </IonModal>) : null}
    </React.Fragment>
    )
}